import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import CallDeleteActions from 'actions/CallDeleteActions';
import {Record} from 'immutable';
import ToastStore from '@store/toast/ToastStore';

const State = Record({
  callId: null,
  isConfirmed: false,
  isDeleting: false,
  isDeleted: false,
  isDeleteError: false,
});

@immutableStore
class CallDeleteStore {
  constructor() {
    this.state = new State();
    this.bindActions(CallDeleteActions);
  }
  setCallId(callId) {
    this.setState({
      callId: callId,
      isConfirmed: false,
      isDeleting: false,
      isDeleted: false,
      isDeleteError: false,
    });
  }
  confirmToggle(isConfirmed) {
    this.setState({
      isConfirmed: isConfirmed,
    });
  }
  deleteCallLoading() {
    this.setState({
      isDeleting: true,
    });
  }
  deleteCallSuccess() {
    this.setState({
      isDeleting: false,
      isDeleted: true,
      isDeleteError: false,
    });
    ToastStore.addToast({
      type: 'success',
      time: 2000,
      message: 'Call deleted',
    });
  }
  deleteCallError() {
    this.setState({
      isDeleting: false,
      isDeleteError: true,
    });
  }
}

export default alt.createStore(CallDeleteStore, 'CallDeleteStore');
